import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ScheduledTask\DuplicateScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/DuplicateScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}/duplicate'
*/
const DuplicateScheduledTaskController = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateScheduledTaskController.url(args, options),
    method: 'post',
})

DuplicateScheduledTaskController.definition = {
    methods: ["post"],
    url: '/api/scheduled-task/{scheduled_task}/duplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ScheduledTask\DuplicateScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/DuplicateScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}/duplicate'
*/
DuplicateScheduledTaskController.url = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { scheduled_task: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { scheduled_task: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            scheduled_task: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        scheduled_task: typeof args.scheduled_task === 'object'
        ? args.scheduled_task.id
        : args.scheduled_task,
    }

    return DuplicateScheduledTaskController.definition.url
            .replace('{scheduled_task}', parsedArgs.scheduled_task.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ScheduledTask\DuplicateScheduledTaskController::__invoke
* @see app/Http/Controllers/ScheduledTask/DuplicateScheduledTaskController.php
* @route '/api/scheduled-task/{scheduled_task}/duplicate'
*/
DuplicateScheduledTaskController.post = (args: { scheduled_task: string | number | { id: string | number } } | [scheduled_task: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateScheduledTaskController.url(args, options),
    method: 'post',
})

export default DuplicateScheduledTaskController